import { createReducer, on } from '@ngrx/store';

import { setAuthEmail, clearAuthState } from './auth.actions';
import { INITIAL_AUTH_STATE } from './auth.state';

export const authReducer = createReducer(
  INITIAL_AUTH_STATE,
  on(setAuthEmail, (state, { email }) => ({ ...state, email })),
  on(clearAuthState, () => INITIAL_AUTH_STATE)
);
